import React from 'react';

// Pulse waveform logo (line-only mark) from the Claude Design system.
const PulseWaveLogo = ({ width = 98, height = 50, color = '#BE5310', strokeWidth = 11, className = '' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 260 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Pulse logo"
    >
      <polyline
        points="8,66 52,66 66,48 88,110 98,22 118,93 130,46 142,93 162,22 172,110 194,48 208,66 252,66"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PulseWaveLogo;
